import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { compose } from "recompose";

// Hooks
import { useLocation } from "react-router-dom";
import useStyles from "@hooks/useStyles";
import useStores from "@libs/framework/src/hooks/useStores";

import Avatar from "@material-ui/core/Avatar";

// Components
import LinkTo from "@custom/LinkTo";
import ProListItemContent from "./ProListItemContent";

import { replaceUrlParam } from "@utils/Browser";
import FinalPrice from "@components/Global/Custom/FinalPrice";
import Button from "@material-ui/core/Button";
import ButtonBase from "@material-ui/core/ButtonBase";
import SendOutlinedIcon from "@material-ui/icons/SendOutlined";
import withStores from "@libs/framework/src/libs/withStores";
import withStyles from "@framework/src/libs/withStyles";

const { SITE_NAME } = process.env;
import { styles, stores } from "./.config";
import LazyLoadComponent from "@custom/LazyLoad";

const ProListItem = compose(
	withStores(stores),
	withStyles(styles),
	observer
)(({ provider, variant, leadKey, serveCity }) => {
	const classes = useStyles("ProList");
	const location = useLocation();

	const {
		proListItemStore: store,
		proListStore,
		sendProjectStore,
	} = useStores();

	let search = location.search;
	if (proListStore.urlServiceKey) {
		search = replaceUrlParam(
			search,
			proListStore.isMidtail ? "midtail" : "service",
			proListStore.urlServiceKey
		);
	}

	const sendRequestOnClickHandler = (e) => {
		e.preventDefault();
		sendProjectStore.init({ leadKey, providerId: provider._id });
	};

	const contactOnClickHandler = (e) => {
		e.preventDefault();
		store.contactPro(provider._id);
		store.showLeadFunnel();
	};

	return (
		<LinkTo
			pathname={store.profileLink(provider)}
			search={search}
			variant={variant}
		>
			<article
				className={classes.proBox}
				onMouseOver={(e) =>
					store.handleMouseOver(e, {
						proID: provider._id,
						position: {
							lat: provider.business_location.lat,
							lng: provider.business_location.lng_,
						},
					})
				}
			>
				<div className={classes.proBoxFlex}>
					<LazyLoadComponent>
						<Avatar
							id={provider._id}
							variant={"rounded"}
							className={classes.proImg}
							alt={provider.company_name.ucFirst()}
							title={provider.company_name.ucFirst()}
							src={provider.image?.value}
							imgProps={{
								loading: "lazy",
								decoding: "async",
								fetchpriority: "auto",
							}}
						/>
					</LazyLoadComponent>
					<ProListItemContent
						provider={provider}
						leadKey={leadKey}
						serveCity={serveCity}
					/>
					<div className={classes.proPriceWrapper}>
						{store.leadFunnelExists && !leadKey ? (
							<ButtonBase variant={"text"} onClick={contactOnClickHandler}>
								<FinalPrice
									total={provider.estimated_price?.total}
									unit={provider.estimated_price?.unit}
								/>
							</ButtonBase>
						) : (
							<FinalPrice
								total={provider.estimated_price?.total}
								unit={provider.estimated_price?.unit}
							/>
						)}

						<div className={classes.proButtons}>
							{["homeguide", "fash"].includes(SITE_NAME) && !leadKey && (
								<>
									<div className={classes.proButtonsSpacing}>
										<Button
											onClick={contactOnClickHandler}
											fullWidth
											disableElevation
											variant="contained"
											color="primary"
										>
											Request a quote
										</Button>
									</div>
									<Button
										fullWidth
										disableElevation
										variant="outlined"
										color="primary"
									>
										View profile
									</Button>
								</>
							)}
							{leadKey ? (
								<Button
									onClick={sendRequestOnClickHandler}
									disableElevation
									variant="contained"
									color="primary"
									startIcon={<SendOutlinedIcon />}
								>
									Send request
								</Button>
							) : (
								!["homeguide", "fash"].includes(SITE_NAME) && (
									<Button
										fullWidth
										disableElevation
										variant="contained"
										color="primary"
									>
										View profile
									</Button>
								)
							)}
						</div>
					</div>
				</div>
			</article>
		</LinkTo>
	);
});

ProListItem.propTypes = {
	provider: PropTypes.object.isRequired,
};

export default ProListItem;
